import SideMenu from '@/containers/side-menu/SideMenu.vue'
import RegisterEmployee from '@/pages/register-employee/RegisterEmployee'

export default {
  path: '/register-employee',
  name: 'RegisterEmployee',
  components: {
    mainContent: RegisterEmployee,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'register-employee'
    },
    breadcrumb: {
      title: 'Cadastro de Funcionário',
      paths: [
        { title: 'Painel de Controle' },
        { title: 'Funcionário' }
      ]
    }
  }
}